"use strict";
function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while (++index < length) {
        if (array[index] === value) {
            return index;
        }
    }
    return -1;
}
module.exports = strictIndexOf;
//# sourceMappingURL=_strictIndexOf.js.map